<ng-template #imageZoom let-data let-ref="dialogRef">
    <nb-card style="max-width: 800px;">
        <nb-card-body>
            <img style="max-width: 100%;" src="{{data}}">
        </nb-card-body>
        <nb-card-footer style="background: #266380;border: none;">
            <button (click)="dialogRef.close()" nbButton>Close</button>
        </nb-card-footer>
    </nb-card>
</ng-template>